import type { ReactNode } from "react";

type Tone = "gold" | "red" | "green";
type Props = { tone?: Tone; variant?: "filled" | "soft"; className?: string; children: ReactNode };

const filled: Record<Tone, string> = {
  gold: "bg-gold text-paper-2",
  red: "bg-red text-paper-2",
  green: "bg-green text-paper-2",
};
const soft: Record<Tone, string> = {
  gold: "bg-gold-soft text-gold-deep",
  red: "bg-red-soft text-red-deep",
  green: "bg-green-soft text-green-deep",
};

export function Badge({ tone = "gold", variant = "soft", className = "", children }: Props) {
  const tones = variant === "filled" ? filled : soft;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${tones[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
